// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DonutSliceChart from '../common/DonutSliceChart';
import SecurityDetailCorrelationListCategory from './SecurityDetailCorrelationListCategory';
import SecurityDetailColorLegend from './SecurityDetailColorLegend';
import { generateSecurityOverviewSliceChartProps } from '../../utils/securityAnalysis';
// css
import '../../styles/components/analytics/SecurityDetail.scss';


class SecurityDetail extends Component {

  getTitle() {
    if (this.props.adequacy === 'acceptable') {
      return 'Fueled Requirements';
    }

    return 'Under-Fueled Requirements';
  }

  renderCategories() {
    const {
      criticality,
      adequacy,
      itemizedData,
      categoryCorrelationsLimit,
      showAdditionalCounts
    } = this.props;
    const categories = itemizedData[criticality][adequacy];

    return categories.map((category, index) => (
      <div
        key={index}
        className='col-md-3 analytics__security-detail-correlation-section'
      >
        <SecurityDetailCorrelationListCategory
          limit={categoryCorrelationsLimit}
          criticality={criticality}
          adequacy={adequacy}
          category={category}
          showAdditionalCount={showAdditionalCounts}
        />
      </div>
    ));
  }

  renderChart() {
    const {
      criticality,
      adequacy,
      aggregateData
    } = this.props;

    return (
      <div className='col-md-3'>
        <div className='analytics__security-detail__chart-container'>
          <DonutSliceChart
            {...generateSecurityOverviewSliceChartProps(aggregateData, criticality, adequacy)}
            strokeWidthPercent={10}
            fontSize={64}
          />
          <SecurityDetailColorLegend
            criticality={criticality}
            adequacy={adequacy}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      criticality,
      adequacy
    } = this.props;

    return (
      <div
        id={`pptx_security_${criticality === 'critical' ? 'critical' : 'non_critical'}_${adequacy}_detail`}
        className='analytics__security-detail'
      >
        <h2>Security Recommendation: {this.getTitle()}</h2>
        <div className='box'>
          <div className='row'>
            {this.renderChart()}
            {this.renderCategories()}
          </div>
        </div>
      </div>
    );
  }
}

SecurityDetail.defaultProps = {
  categoryCorrelationsLimit: 99999,
  showAdditionalCounts: false
};

SecurityDetail.propTypes = {
  criticality: PropTypes.string.isRequired,
  adequacy: PropTypes.string.isRequired,
  aggregateData: PropTypes.object.isRequired,
  itemizedData: PropTypes.object.isRequired,
  categoryCorrelationsLimit: PropTypes.number,
  showAdditionalCounts: PropTypes.bool
};

export default SecurityDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDetail.js